import { render, staticRenderFns } from "./remove-gateway-from-site.vue?vue&type=template&id=3a0bff03&"
import script from "./remove-gateway-from-site.vue?vue&type=script&lang=ts&"
export * from "./remove-gateway-from-site.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports